import { type TabBarEntry } from '@/components/Tabs';
import { BANK_FEED_ROUTE_TABS, type BankFeedRouteTab } from '@/domain/bankFeed/constants';
import { type CompanyBankFeedDestinationKey } from '@/abilities/companyBankFeed/vocabulary';

/** The Bank Feed tab bar, in the order it shows the tabs. Where the bare address leads is the tree's own order. */
export const companyBankFeedTabBar: ReadonlyArray<
  TabBarEntry<CompanyBankFeedDestinationKey> & { readonly segment: BankFeedRouteTab }
> = [
  {
    destination: 'transactions',
    segment: BANK_FEED_ROUTE_TABS.TRANSACTIONS,
    label: { id: 'company.bankFeed.transactions.tab.bank', defaultMessage: 'Bank Transactions' },
  },
  {
    destination: 'creditCards',
    segment: BANK_FEED_ROUTE_TABS.CREDIT_CARDS,
    label: { id: 'company.bankFeed.transactions.tab.creditCard', defaultMessage: 'Credit Card Transactions' },
  },
];
